import { c as _c } from "react/compiler-runtime";
import type { DropMetadata } from "@/entities/IDrop";
import CreateDropMetadataItem from "./CreateDropMetadataItem";
export default function CreateDropMetadataItems(t0) {
  const $ = _c(7);
  const {
    items,
    onMetadataRemove
  } = t0;
  let t1;
  if ($[0] !== items || $[1] !== onMetadataRemove) {
    let t2;
    if ($[3] !== onMetadataRemove) {
      t2 = item => <CreateDropMetadataItem key={item.data_key} item={item} onMetadataRemove={onMetadataRemove} />;
      $[3] = onMetadataRemove;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = items.map(t2);
    $[0] = items;
    $[1] = onMetadataRemove;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="tw-mb-3 lg:tw-mt-2 tw-flex tw-flex-wrap tw-gap-y-2 tw-gap-x-2">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}